import React, { useRef, useState } from "react";
import {
  ProductDescription,
  ProductTypeName,
  ProductItem,
  ProductTypeValue,
  ProductPlay,
  ProductVideo,
  PlayIcon,
} from "../Customizer/ProductInfo/styles";

export default function MonogramWhatFits({ data }) {
  const vidRef = useRef(null);
  const [isPlay, setIsPlay] = useState(true);
  const handlePlayVideo = () => {
    setIsPlay(!isPlay);
    isPlay ? vidRef.current.play() : vidRef.current.pause();
  };

  const description = data?.description;
  const measurements = data?.measurements;
  const what_fits = data?.what_fits;
  const what_fits_video = data?.what_fits_video?.[0];

  function renderWhatFits(what_fits) {
    try {
      const items = what_fits.split(",");
      if (items.length <= 1) {
        return what_fits;
      }

      return (
        <ul>
          {items.map((item, i) => (
            <li key={`${item}-${i}`}>{item}</li>
          ))}
        </ul>
      );
    } catch (error) {
      return what_fits;
    }
  }

  return (
    <>
      {description && <ProductDescription>{description}</ProductDescription>}
      {measurements && (
        <ProductItem>
          <ProductTypeName>Dimensions</ProductTypeName>
          <ProductTypeValue dangerouslySetInnerHTML={{ __html: measurements }} />
        </ProductItem>
      )}
      {what_fits && (
        <ProductItem>
          <ProductTypeName>Fits These Items:</ProductTypeName>
          <ProductTypeValue>{renderWhatFits(what_fits)}</ProductTypeValue>
        </ProductItem>
      )}
      {what_fits_video && (
        <ProductItem>
          <ProductVideo>
            <video ref={vidRef} preload="metadata" controls>
              <source src={what_fits_video + "#t=0.001"} type="video/mp4" />
            </video>
            <ProductPlay onClick={handlePlayVideo}>{isPlay ? <PlayIcon /> : ""}</ProductPlay>
          </ProductVideo>
        </ProductItem>
      )}
    </>
  );
}
